import { apiClient } from '@/api/client'

export interface CreateChatPayload {
  name: string
  type: string
  description?: string
  participants?: number[]
  context_type?: string
  context_id?: number
}

export interface UpdateChatPayload {
  name?: string
  description?: string
}

export const chatApi = {
  async getChats(params?: {
    page?: number
    limit?: number
    type?: string
    search?: string
    sort?: string
    direction?: string
    archived?: boolean
  }) {
    return apiClient.get('/api/chats', { params })
  },

  async getChat(chatId: number) {
    return apiClient.get(`/api/chats/${chatId}`)
  },

  async createChat(body: CreateChatPayload) {
    return apiClient.post('/api/chats', body)
  },

  async updateChat(chatId: number, body: UpdateChatPayload) {
    return apiClient.put(`/api/chats/${chatId}`, body)
  },

  async getParticipants(chatId: number) {
    return apiClient.get(`/api/chats/${chatId}/participants`)
  },

  async addParticipant(chatId: number, body: { user_id: number }) {
    return apiClient.post(`/api/chats/${chatId}/participants`, body)
  },

  async removeParticipant(chatId: number, userId: number) {
    return apiClient.delete(`/api/chats/${chatId}/participants/${userId}`)
  },

  async leaveChat(chatId: number) {
    return apiClient.post(`/api/chats/${chatId}/leave`)
  },

  async archiveChat(chatId: number) {
    return apiClient.post(`/api/chats/${chatId}/archive`)
  },

  async unarchiveChat(chatId: number) {
    return apiClient.post(`/api/chats/${chatId}/unarchive`)
  },

  async getMessages(chatId: number, params: { page: number; limit: number }) {
    return apiClient.get(`/api/chats/${chatId}/messages`, { params })
  },

  async sendMessage(chatId: number, body: { content: string }) {
    return apiClient.post(`/api/chats/${chatId}/messages`, body)
  },

  async editMessage(chatId: number, id: number, body: { content: string }) {
    return apiClient.put(`/api/chats/${chatId}/messages/${id}`, body)
  },

  async deleteMessage(chatId: number, id: number) {
    return apiClient.delete(`/api/chats/${chatId}/messages/${id}`)
  },

  async uploadFile(chatId: number, file: File, description?: string) {
    const form = new FormData()
    form.append('file', file)
    if (description !== undefined && description !== '') {
      form.append('description', description)
    }
    return apiClient.post(`/api/chats/${chatId}/files/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
